import React, { FC, ReactNode } from 'react';
import { Trans } from 'react-i18next';
import { Divider, Grid, Link, List, Paper, Typography } from '@material-ui/core';
import { createStyles, withStyles, Theme, WithStyles } from '@material-ui/core/styles';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';

import { generateLink } from 'Links';

interface IProps extends WithStyles<typeof styles> {
  color: 'primary' | 'secondary';
  title: ReactNode;
  link?: string;
}

const styles = (theme: Theme) =>
  createStyles({
    list: {
      padding: theme.spacing(2),
    },
    link: {
      display: 'flex',
      fontSize: theme.typography.pxToRem(13),
    },
    linkIcon: {
      marginLeft: theme.spacing(0.5),
      fontSize: 16,
    },
    divider: {
      height: 1,
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(2),
    },
  });

const ListWidget: FC<IProps> = ({ classes, color, title, link, children }) => (
  <Paper className={classes.list}>
    <Grid container alignItems="baseline" justify="space-between">
      <Grid item>
        <Typography color={color} variant="subtitle2">
          {title}
        </Typography>
      </Grid>
      {link && (
        <Grid item>
          <Typography>
            <Link component={generateLink(link)} className={classes.link}>
              <Trans i18nKey="components:seeAll" />
              <ChevronRightIcon className={classes.linkIcon} />
            </Link>
          </Typography>
        </Grid>
      )}
    </Grid>
    <Divider className={classes.divider} />
    <List>{children}</List>
  </Paper>
);

export default withStyles(styles)(ListWidget);
